import { useEffect } from 'react'
import { IResponseState } from '../ResponseModal/module/constants'
import { Modal } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import classes from './CaMobileResponseModal.module.scss'
import messages from './module/messages'
import { FaCheckCircle, FaRegTimesCircle } from 'react-icons/fa'
import Loader from '../../Loader/Loader'

interface CaMobileResponseModalProps {
  show: boolean
  state: IResponseState
  onClose: () => void
}

const CaMobileResponseModal = (props: CaMobileResponseModalProps) => {
  const { onClose, show, state } = props

  useEffect(() => {
    if (state === IResponseState.SUCCESS) {
      onClose()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state])

  return (
    <>
      <Modal show={show} centered contentClassName={classes.content}>
        <Modal.Header className={classes.header}>
          <Modal.Title style={{ fontSize: '1rem' }}>
            {state === IResponseState.ERROR && (
              <FormattedMessage {...messages.errorTitle} />
            )}
            {state === IResponseState.PENDING && (
              <FormattedMessage {...messages.pendingTitle} />
            )}
            {state === IResponseState.SUCCESS && (
              <FormattedMessage {...messages.successTitle} />
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: '0.75rem' }}>
          <div className={classes['body-content']}>
            <div className={classes['gif-container']}>
              {state === IResponseState.ERROR && (
                <div className={classes['warn']}>
                  <FaRegTimesCircle />
                </div>
              )}
              {state === IResponseState.PENDING && <Loader />}
              {state === IResponseState.SUCCESS && (
                <div className={classes['success']}>
                  <FaCheckCircle />
                </div>
              )}
            </div>
            <div className={classes['text-content']}>
              {state === IResponseState.ERROR && (
                <>
                  <FormattedMessage {...messages.errorBodyContent} />
                </>
              )}
              {state === IResponseState.PENDING && (
                <FormattedMessage {...messages.pendingBodyContent} />
              )}
              {state === IResponseState.SUCCESS && (
                <>
                  <FormattedMessage {...messages.successBodyContent} />
                </>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className={classes.footer}>
          <button
            className={`${classes.btn} ${classes['btn-cancel']}`}
            onClick={onClose}
          >
            <FormattedMessage {...messages.close} />
          </button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default CaMobileResponseModal
